import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { LoggerService, SpinnerService, TranslateService } from 'farmcloud-core';
import { CheckDeviceService } from './core/check-device/check-device.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit {
  public isLoading$ = this.spinnerService.status$;
  constructor(
    private readonly translateService: TranslateService,
    private readonly loggerService: LoggerService,
    private readonly spinnerService: SpinnerService,
    public readonly checkDeviceService: CheckDeviceService
  ) {}

  ngOnInit(): void {
    this.translateService.initialize();
    this.loggerService.initialize();
  }
}
